import React, { memo } from "react";

import './styles.scss';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';

import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';

const Modal = ({open, close, titulo, size, type, children, classTop}) => {
    return (
        <Dialog 
            open={open}
            onClose={close}
            className={type}
            aria-labelledby="customized-dialog-title"
            maxWidth={size ? size : 'lg'}
        >
            <DialogTitle id="form-dialog-title" className={classTop}>
                <Typography>{titulo}</Typography>
                <IconButton aria-label="close" onClick={close}><CloseIcon /></IconButton>
            </DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
        </Dialog>
    )
}

export default memo(Modal);